module.exports = __webpack_public_path__ + "img/img-title-effect.6bac361d.png";